// src/pages/SuperAdmin/AdminDashboard.tsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchResumo } from "../../services/adminApi";
import {
  PeopleAlt,
  HourglassEmpty,
  Agriculture,
  WhatsApp,
} from "@mui/icons-material";

type Resumo = {
  total_usuarios: number;
  total_temporarios: number;
  total_fazendas: number;
  total_contatos_whatsapp: number;
};

const cards = [
  {
    key: "total_usuarios" as keyof Resumo,
    label: "Usuários Cadastrados",
    icon: <PeopleAlt />,
    color: "#00b37e",
    bg: "#e8f4ef",
    path: "/superadmin/usuarios",
  },
  {
    key: "total_temporarios" as keyof Resumo,
    label: "Usuários Temporários",
    icon: <HourglassEmpty />,
    color: "#f59e0b",
    bg: "#fef3c7",
    path: "/superadmin/pendentes",
  },
  {
    key: "total_fazendas" as keyof Resumo,
    label: "Unidades de Produção",
    icon: <Agriculture />,
    color: "#3b82f6",
    bg: "#eff6ff",
    path: "/superadmin/fazendas",
  },
  {
    key: "total_contatos_whatsapp" as keyof Resumo,
    label: "Contatos WhatsApp",
    icon: <WhatsApp />,
    color: "#25d366",
    bg: "#d8f5e5",
    path: "/superadmin/whatsapp",
  },
];

const AdminDashboard: React.FC = () => {
  const navigate = useNavigate();
  const [resumo, setResumo] = useState<Resumo | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchResumo()
      .then(setResumo)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ padding: "32px 28px", maxWidth: 1100, width: "100%" }}>
      {/* Header */}
      <div style={{ marginBottom: 32 }}>
        <div style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          background: "#ff6b2b",
          borderRadius: 8,
          padding: "4px 12px",
          marginBottom: 10,
        }}>
          <span style={{ fontSize: "0.72rem", fontWeight: 700, color: "#fff", letterSpacing: 1 }}>
            PAINEL ADMINISTRATIVO
          </span>
        </div>
        <h1 style={{ margin: 0, fontSize: "1.8rem", fontWeight: 700, color: "#1a2e1e" }}>
          Visão Geral da Plataforma
        </h1>
        <p style={{ margin: "6px 0 0", color: "#6b7280", fontSize: "0.95rem" }}>
          Monitoramento de usuários, fazendas e conversas WhatsApp
        </p>
      </div>

      {/* Cards */}
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
        gap: 20,
        marginBottom: 40,
      }}>
        {cards.map((card) => (
          <button
            key={card.key}
            onClick={() => navigate(card.path)}
            style={{
              background: "#fff",
              border: `1.5px solid ${card.bg}`,
              borderRadius: 16,
              padding: "24px 20px",
              cursor: "pointer",
              textAlign: "left",
              transition: "all 0.18s",
              boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
            }}
            onMouseEnter={(e) => {
              (e.currentTarget as HTMLButtonElement).style.transform = "translateY(-3px)";
              (e.currentTarget as HTMLButtonElement).style.boxShadow = "0 8px 24px rgba(0,0,0,0.1)";
            }}
            onMouseLeave={(e) => {
              (e.currentTarget as HTMLButtonElement).style.transform = "translateY(0)";
              (e.currentTarget as HTMLButtonElement).style.boxShadow = "0 2px 8px rgba(0,0,0,0.06)";
            }}
          >
            <div style={{
              width: 44,
              height: 44,
              borderRadius: 12,
              background: card.bg,
              color: card.color,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 14,
            }}>
              {card.icon}
            </div>
            <div style={{ fontSize: "2rem", fontWeight: 800, color: "#1a2e1e", lineHeight: 1 }}>
              {loading ? "—" : (resumo?.[card.key] ?? 0)}
            </div>
            <div style={{ fontSize: "0.85rem", color: "#6b7280", marginTop: 4 }}>
              {card.label}
            </div>
          </button>
        ))}
      </div>

      {/* Atalhos rápidos */}
      <div style={{
        background: "#f8faf9",
        borderRadius: 14,
        padding: "20px 24px",
        border: "1px solid #e5ede8",
      }}>
        <h3 style={{ margin: "0 0 14px", fontSize: "0.9rem", fontWeight: 700, color: "#374151", textTransform: "uppercase", letterSpacing: 0.5 }}>
          Acesso rápido
        </h3>
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
          {cards.map((card) => (
            <button
              key={card.key}
              onClick={() => navigate(card.path)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                padding: "8px 16px",
                border: `1px solid ${card.bg}`,
                borderRadius: 8,
                background: "#fff",
                cursor: "pointer",
                fontSize: "0.875rem",
                color: card.color,
                fontWeight: 600,
                transition: "background 0.15s",
              }}
            >
              {card.icon}
              {card.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
